import "./_paggination.scss";

import {ReactElement, useRef} from "react";

import Button from "@/components/Button/Button";

import SelectCustom from "../SelectCustom/SelectCustom";

export type pagination = {
  total: number;
  page: number;
  items_per_page: number;
};

export function Pagination({
  pagination = {total: 0, page: 1, items_per_page: 10},
  onChangePage,
  onChangeItemsPerPage,
}: {
  pagination?: pagination;
  onChangePage: (value: number) => void;
  onChangeItemsPerPage: (value: number) => void;
}): ReactElement {
  const inputPageRef = useRef<HTMLInputElement>(null);
  const lastPage: number = Math.ceil(
    pagination.total / pagination.items_per_page,
  );
  const ButtonPagginate = (number: number): ReactElement => {
    return (
      <div
        className={`pagination-button ${
          number.toString() === pagination?.page.toString()
            ? "pagination-button--active"
            : ""
        }`}
        key={number}
        onClick={() => {
          onChangePage(number);
        }}>
        {number}
      </div>
    );
  };
  const allButton = [];

  const endpagination = Math.min(lastPage, pagination?.page + 3);
  const startPaggintaion = Math.max(1, pagination?.page - 3);

  const goFirstPage =
    startPaggintaion > 1 ? (
      <div
        className="pagination-link"
        onClick={() => {
          onChangePage(1);
        }}>
        Première page
      </div>
    ) : null;
  const goLastPage =
    endpagination < lastPage ? (
      <div
        className="pagination-link"
        onClick={() => {
          onChangePage(lastPage);
        }}>
        Dernière page
      </div>
    ) : null;
  for (let index = startPaggintaion; index <= endpagination; index++) {
    allButton.push(ButtonPagginate(index));
  }

  const selectPage =
    allButton.length <= lastPage ? (
      <form
        className="pagination-selectPage"
        onSubmit={event => {
          event.preventDefault();

          if (inputPageRef?.current) {
            const value = parseInt(inputPageRef.current.value);
            onChangePage(value > lastPage ? lastPage : value);
          }
        }}>
        <label htmlFor=""> Page n° : </label>
        <div>
          <input
            className="inputLabel"
            type="number"
            min={1}
            max={lastPage}
            defaultValue={pagination?.page}
            ref={inputPageRef}
          />
          <Button
            label="Go"
            type="submit"
            variant="secondary"
            onClick={() => {}}
          />
        </div>
      </form>
    ) : null;
  return (
    <div className="pagination">
      <div className="pagination-itemsPerPage">
        <label> Nb résultat par page : </label>
        <SelectCustom
          name="pagination"
          defaultValue={pagination.items_per_page.toString()}
          options={[
            {libelle: "10", value: 10},
            {libelle: "25", value: 25},
            {libelle: "50", value: 50},
          ]}
          handleSelect={value => {
            onChangeItemsPerPage(value);
          }}
          listIsAbsolute={false}
        />
      </div>
      <div className="pagination-allButton">
        {goFirstPage}
        {allButton}
        {goLastPage}
      </div>
      {selectPage}
    </div>
  );
}
